"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const ButtonTypes_1 = require("../../components/atoms/Button/ButtonTypes");
const colors = {
    primary: {
        200: '#00009680',
        500: '#000096',
    },
};
const theme = {
    bpCore: {
        colors,
        button: {
            type: {
                [ButtonTypes_1.ButtonAction.PRIMARY]: {
                    inverted: {
                        color: colors.primary[500],
                    },
                    disabled: {
                        backgroundColor: colors.primary[200],
                    },
                    backgroundColor: colors.primary[500],
                },
                [ButtonTypes_1.ButtonAction.SECONDARY]: {
                    borderColor: colors.primary[500],
                    disabled: {
                        borderColor: colors.primary[200],
                    },
                },
                [ButtonTypes_1.ButtonAction.TERTIARY]: {
                    color: colors.primary[500],
                    disabled: {
                        color: colors.primary[200],
                    },
                },
                [ButtonTypes_1.ButtonAction.SENARY]: {
                    color: colors.primary[500],
                    disabled: {
                        color: colors.primary[200],
                    },
                    horizontalPadding: false,
                },
            },
        },
    },
};
exports.theme = theme;
